import api from '../../api';

export const fetchSuytDraft = () => api.get('/suyt-draft');

export const submitSuytPrediction = ({ displayName, ouScore, osuScore }) => (
  api.post('/suyt-draft/predictions', { displayName, ouScore, osuScore })
);

export const submitSuytResults = ({ adminKey, ouActual, osuActual }) => (
  api.post('/suyt-draft/results', { adminKey, ouActual, osuActual })
);

export const claimSuytDraftSlot = ({ predictionId, draftSlot }) => (
  api.post('/suyt-draft/draft-slot', { predictionId, draftSlot })
);

export const resetSuytDraftSlots = (adminKey) => (
  api.post('/suyt-draft/reset-slots', { adminKey })
);

export const deleteSuytPrediction = ({ adminKey, id }) => (
  api.delete(`/suyt-draft/predictions/${id}`, {
    data: { adminKey },
  })
);
